(() => {
  const api = window.GutSuppCartGifts;
  if (!api || window.__gutSuppGiftUi) return;
  window.__gutSuppGiftUi = true;
  const root = window.Shopify?.routes?.root || '/';
  let purchasing = false;
  let locked = [];
  const status = message => document.querySelectorAll('.cro-cart-status').forEach(node => { node.textContent = message; });
  const render = (cart, open) => {
    const detail = { response: cart, handled: false, open };
    document.dispatchEvent(new CustomEvent('gutsupp:open-cart', { detail }));
    if (!detail.handled) throw new Error(api.config.error);
  };
  const request = async (path, body) => {
    const response = await fetch(root + path, { method: body === undefined ? 'GET' : 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body === undefined ? {} : {body: JSON.stringify(body)}) });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || api.config.error);
    return data;
  };
  api.configureHooks({
    onBusy(busy) {
      document.querySelectorAll('.cart-aside__form').forEach(form => form.setAttribute('aria-busy', String(busy)));
      if (busy) {
        status('');
        locked = [...document.querySelectorAll('.cart-aside__form button, .cart-aside__form select')].map(node => ({node, disabled:node.disabled}));
        locked.forEach(({node}) => { node.disabled = true; });
      } else {
        locked.forEach(({node, disabled}) => { if (node.isConnected) node.disabled = disabled; });
        locked = [];
      }
    },
    onError(error) { status(error ? api.config.error : ''); }
  });
  const mutate = operation => api.run(async ({reconcile}) => {
    await operation();
    const cart = await reconcile({sections:true});
    render(cart, true);
    return cart;
  }).catch(() => {});
  const markRemoving = button => {
    const disabled = button.disabled;
    const busy = button.getAttribute('aria-busy');
    button.setAttribute('data-gs-removing', '');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    return () => {
      button.removeAttribute('data-gs-removing');
      if (busy === null) button.removeAttribute('aria-busy');
      else button.setAttribute('aria-busy', busy);
      button.disabled = disabled;
    };
  };
  document.addEventListener('gutsupp:purchase-state', event => { purchasing = Boolean(event.detail?.busy); });
  document.addEventListener('click', event => {
    const checkout = event.target.closest('a[name="checkout"], a[href="/checkout"], input[name="checkout"], button[name="checkout"]');
    if (checkout) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (purchasing || api.busy) return;
      api.run(async ({reconcile}) => {
        const cart = await reconcile({sections:false});
        if (cart.item_count) window.location.assign(root + 'checkout');
        else render(cart, true);
      }).catch(() => {});
      return;
    }
    const button = event.target.closest('.cart-aside__item-delete, .quantity__minus, .quantity__plus, [data-cart-upgrade], .type-button');
    const row = button?.closest('.cart-aside__item');
    if (!row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (purchasing || api.busy || button.disabled || button.hasAttribute('data-gs-removing')) return;
    const quantity = Number(row.querySelector('.quantity__value')?.value || 1);
    const body = {id:row.dataset.itemKey, quantity};
    const deleting = button.matches('.cart-aside__item-delete');
    if (deleting) body.quantity = 0;
    else if (button.matches('.quantity__minus')) body.quantity = Math.max(0,quantity-1);
    else if (button.matches('.quantity__plus')) body.quantity = quantity+1;
    else if (button.matches('[data-cart-upgrade]')) body.selling_plan = Number(button.dataset.sellingPlan);
    else {
      const selected = row.querySelector('.type-subscriptions__plans');
      const plan = selected?.selectedOptions[0]?.dataset.plan || row.dataset.defaultSellingPlanId;
      body.selling_plan = button.classList.contains('type-button--subscribe') ? Number(plan) : null;
    }
    const restoreDeleteButton = deleting ? markRemoving(button) : null;
    mutate(async () => {
      if (row.dataset.aggregateParent === 'true' && !button.matches('[data-cart-upgrade], .type-button')) {
        const cart = await request('cart.js');
        const canonical = properties => JSON.stringify(Object.entries(Array.isArray(properties) ? Object.fromEntries(properties) : properties || {}).sort(([a],[b]) => a.localeCompare(b)));
        const properties = canonical(JSON.parse(row.dataset.groupProperties || '{}'));
        const peers = cart.items.filter(item => String(item.variant_id) === row.dataset.variantId && String(item.selling_plan_allocation?.selling_plan?.id || '') === row.dataset.sellingPlanId && canonical(item.properties) === properties);
        if (!peers.length) throw new Error(api.config.error);
        const updates = Object.fromEntries(peers.map((item,index) => [item.key,index === 0 ? body.quantity : 0]));
        await request('cart/update.js',{updates});
      } else await request('cart/change.js',body);
    }).finally(() => { if (restoreDeleteButton) restoreDeleteButton(); });
  }, true);
  document.addEventListener('change', event => {
    const select = event.target.closest('.cart-aside__item .variant-select, .cart-aside__item .type-subscriptions__plans');
    if (!select) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (purchasing || api.busy) return;
    const row = select.closest('.cart-aside__item');
    const quantity = Number(row.querySelector('.quantity__value')?.value || 1);
    const option = select.selectedOptions[0];
    mutate(async () => {
      if (select.matches('.variant-select')) {
        await request('cart/change.js',{id:row.dataset.itemKey,quantity:0});
        await request('cart/add.js',{items:[{id:Number(option.dataset.id),quantity}]});
      } else await request('cart/change.js',{id:row.dataset.itemKey,quantity,selling_plan:Number(option.dataset.plan)});
    });
  }, true);
  document.addEventListener('submit', event => {
    if (!event.submitter?.matches('[name="checkout"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (purchasing || api.busy) return;
    api.run(async ({reconcile}) => {
      const cart = await reconcile({sections:false});
      if (cart.item_count) window.location.assign(root+'checkout');
      else render(cart,true);
    }).catch(() => {});
  }, true);
  window.addEventListener('pageshow', () => {
    if (purchasing) return;
    const open = document.querySelector('.cart-aside')?.classList.contains('cart-aside--active') || location.pathname === root+'cart';
    api.run(async ({reconcile}) => render(await reconcile({sections:true}),open)).catch(() => {});
  });
})();


